import React, { memo, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import styles from './image-loader.module.scss';
import { Loader } from '../loader/loader';

interface IProps {
  className?: string;
  fit?: 'cover' | 'contain';
  loaderText?: string;
  src: string;
  style?: React.CSSProperties;
  handleImageLoad?: () => void;
}

function ImageLoader({
  className = '',
  fit = 'cover',
  loaderText = '',
  src,
  style,
  handleImageLoad,
}: IProps) {
  const [isLoading, setIsLoading] = useState(true);
  const imageRef = useRef<HTMLImageElement>(null);

  const onImageLoad = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    const image = imageRef.current;
    if (src && image) {
      image.addEventListener('load', onImageLoad);
      image.addEventListener('error', onImageLoad);
      image.src = src;
    }

    return () => {
      if (image) {
        image.removeEventListener('load', onImageLoad);
        image.removeEventListener('error', onImageLoad);
      }
    };
  }, [src]);

  return (
    <>
      {isLoading && (
        <div className={clsx(className, styles.Loader)}>
          <Loader text={loaderText} />
        </div>
      )}
      <img
        src={isLoading ? undefined : src}
        alt=""
        ref={imageRef}
        className={clsx(styles.Image, isLoading && styles.Loading)}
        style={{
          objectFit: fit,
          ...style,
        }}
        crossOrigin="anonymous"
        onLoad={() => {
          if (!isLoading && handleImageLoad) {
            handleImageLoad();
          }
        }}
      />
    </>
  );
}

export default memo(ImageLoader);
